import { Avatar } from '@heroui/react'

const AVATAR_IMAGES = [
  'https://heroui-assets.nyc3.cdn.digitaloceanspaces.com/avatars/blue.jpg',
  'https://heroui-assets.nyc3.cdn.digitaloceanspaces.com/avatars/green.jpg',
  'https://heroui-assets.nyc3.cdn.digitaloceanspaces.com/avatars/purple.jpg',
  'https://heroui-assets.nyc3.cdn.digitaloceanspaces.com/avatars/orange.jpg',
  'https://heroui-assets.nyc3.cdn.digitaloceanspaces.com/avatars/red.jpg',
]

const getAvatarData = (name: string) => {
  const hash = name.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0)
  const colors: ('default' | 'accent' | 'success' | 'warning' | 'danger')[] = [
    'accent',
    'success',
    'warning',
    'danger',
  ]
  return {
    image: AVATAR_IMAGES[hash % AVATAR_IMAGES.length],
    color: colors[hash % colors.length],
  }
}

const getInitials = (name: string) =>
  name
    .split(' ')
    .slice(0, 2)
    .map(w => w[0])
    .join('')
    .toUpperCase()

interface UserAvatarProps {
  name: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  isDisabled?: boolean;
}

export function UserAvatar({ name, size = 'sm', className, isDisabled }: UserAvatarProps) {
  const { image, color } = getAvatarData(name)
  const initials = getInitials(name)

  return (
    <Avatar size={size} className={`${className} ${isDisabled ? 'grayscale opacity-60' : ''}`}>
      <Avatar.Image src={image} alt={name} />
      <Avatar.Fallback color={color as any}>
        {initials}
      </Avatar.Fallback>
    </Avatar>
  )
}
